import {
  Button,
  CenteredLayout,
  Heading,
  IconLink,
  Logo,
  PancakeStack,
  Text,
  WorkflowHeader,
} from '@betterment/samba-react';

import { urlBuilder } from '~/b4b/utils/urlBuilder';

export const GenerateReportsStep: React.FC = () => {
  return (
    <PancakeStack css={{ maxWidth: '100%' }}>
      <PancakeStack.Header
        css={{
          maxWidth: '100%',
          display: 'flex',
          justifyContent: 'center',
          borderBottom: 'solid thin',
          borderColor: 'border',
        }}
      >
        <WorkflowHeader>
          <WorkflowHeader.Leading>
            <Logo type="b4bSignature" />
          </WorkflowHeader.Leading>
          <WorkflowHeader.Title>Run report</WorkflowHeader.Title>
          <WorkflowHeader.Trailing>
            <IconLink name="X" label="Close" spacing="none" href={urlBuilder.dashboard()} />
          </WorkflowHeader.Trailing>
        </WorkflowHeader>
      </PancakeStack.Header>
      <PancakeStack.Main>
        <CenteredLayout size="medium" css={{ py: 'space.600' }}>
          <Heading>Run a report.</Heading>
          <Text as="p" css={{ my: 'space.300' }}>
            Please select the report you’d like to run, and then specify the date(s) for your report. Your report will
            be generated as a CSV file.
          </Text>
          <Button>Submit</Button>
        </CenteredLayout>
      </PancakeStack.Main>
    </PancakeStack>
  );
};
